import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetTransactionReport  {
    _originalTypeClassName = "zERP.BO.AssetTransactionReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetTransactionReport.translate = translateService;
}
this.Transactions = [];
this.From = null;
this.To = null;
this.Base = null;
this.DepreciationMethod = null;
this.DepreciationFactor = null;
this.AssetTransactionReportKey = null;
this._key = this.AssetTransactionReportKey = 0; 
}

static translate: TranslateService;
_key: any;
From:any;
To:any;
Base:any;
DepreciationMethod:any;
DepreciationFactor:any;
Asset:any;
Transactions:any;
private _AssetTransactionReportKey:any;
get AssetTransactionReportKey(): any {
    return this._AssetTransactionReportKey;
  }
set AssetTransactionReportKey(value: any) {
    this._AssetTransactionReportKey = value;
    this._key = value;
  }
static setAsset = ($this, value) => {
var oldValue = $this.Asset;
$this.Asset = value;
if (value != null) {
}
}
static setTransactions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transactions == null) $this.Transactions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transactions.length > 0) {
                    Domain.AssetTransactionReport.removeTransactions($this, $this.Transactions[0]);
                }

                Domain.AssetTransactionReport.addManyTransactions($this, copyItems);
            }
static addManyTransactions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetTransactionReport.addTransactions($this, items[i]);
                }
            }
static addTransactions = ($this, item) => {
                if ($this.Transactions == null) $this.Transactions = [];
                if (item == null || $this.Transactions.indexOf(item) > -1) return;
                $this.Transactions.push(item);
}
static addRangeTransactions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetTransactionReport.addTransactions($this, item));
            }
static removeTransactions = ($this, item) => {
                if ($this == null || $this.Transactions == null || $this.Transactions.indexOf(item) === -1) return;
                var _index = $this.Transactions.indexOf(item);
                $this.Transactions.splice(_index, 1);
}
static clearTransactions = ($this) => { $this.Transactions = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetTransactionReportKey == null || $this.AssetTransactionReportKey == 0;
            }


}